var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-page-results-counter text-14 font-bold text-center pb-{25px}"},[_vm._v("\n  "+_vm._s(_vm.$t('functional.pageResultsCount', { from: _vm.numberFormat(_vm.from), to: _vm.numberFormat(_vm.to), total: _vm.numberFormat(_vm.total), type: (_vm.type || _vm.$t('functional.results')).toLowerCase() }))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }